module.exports = __webpack_public_path__ + "static/img/yen.f6f661b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/yen.png
// module id = LQ2o
// module chunks = 0